<template>
  <div>
    <wc-section-title title='Construction'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'construction-base',
  computed: {
    menu () {
      return [
        {
          title: this.$store.state.icons.modules.construction.title,
          icon: this.$store.state.icons.modules.construction.icon,
          route: { name: 'ConstructionDashboard' }
        }
      ]
    },
    constructionDivision () {
      return this.$store.state.misc.divisions.find(d => d.division === 'Construction')
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Construction Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>